import React from 'react';
import styled from 'styled-components';
import { materialIcon } from '../styled/utils';
import Tooltip, { TooltipPosition } from '../tooltip/Tooltip';

// tslint:disable-next-line:variable-name
const SRadio = styled.label<{ selected: boolean }>(
  ({ theme, selected }) => `
  display: flex;
  align-items: center;
  color: inherit;
  fontSize: ${theme.font.size.smallMedium};
  font-weight: ${theme.font.weight.light}
  cursor: pointer;
  input[type=radio] {
    display: none;
  }
  &:before {
    cursor: pointer;
    margin-right: ${theme.spacing.medium}px;
    ${materialIcon(selected ? 'radio_button_checked' : 'radio_button_unchecked', 20, 'inherit')}
  }
`,
);

// tslint:disable-next-line:variable-name
const SRadioLabel = styled.span``;

export type RadioOnClick<T> = (value: T) => void;

export interface IRadioOptionsProps<T> {
  label: React.ReactNode;
  value: T;
  addToolTip?: string;
  dataAt: string;
  className?: string;
  describedby?: string;
}

export interface IRadioProps<T> extends IRadioOptionsProps<T> {
  onClick: RadioOnClick<T>;
  selected: boolean;
}

export class Radio<T> extends React.Component<IRadioProps<T>> {
  public static defaultProps = {
    selected: false,
    label: '',
    dataAt: '',
  };

  private handleClick = () => {
    this.props.onClick(this.props.value);
  };

  private handleKey = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.key === 'Enter') {
      this.props.onClick(this.props.value);
    }
  };

  public render() {
    return (
      <SRadio
        role="radio"
        aria-checked={this.props.selected}
        aria-describedby={this.props.describedby}
        tabIndex={0}
        onKeyUp={this.handleKey}
        selected={this.props.selected}
        className={this.props.className}
        data-at={this.props.dataAt}
      >
        <input type="radio" onClick={this.handleClick} value="" />
        <SRadioLabel>{this.props.label}</SRadioLabel>
        {this.props.addToolTip ? (
          <Tooltip
            dataAt="rcc-tooltip"
            width={200}
            position={TooltipPosition.BottomRight}
            toggler={(
              <i aria-label={this.props.addToolTip} className="material-icons" data-at="rcc-tooltip-toggle">
                info
              </i>
            )}
          >
            {this.props.addToolTip}
          </Tooltip>
        ) : (
          <></>
        )}
      </SRadio>
    );
  }
}
